let flags = [];
if (typeof window !== 'undefined') {
  flags = (localStorage?.getItem("flags")?.toLowerCase() || "").split(',').map(a => a.trim());
}

export default function featureFlag(hasFlag: string): boolean {
  return flags.indexOf(hasFlag) >= 0;
}